/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeploymentStepLogDto
 */
export interface DeploymentStepLogDto {
    /**
     * The log line.
     * @type {string}
     * @memberof DeploymentStepLogDto
     */
    message: string;
    /**
     * When the line was reported.
     * @type {Date}
     * @memberof DeploymentStepLogDto
     */
    timestamp: Date;
}

/**
 * Check if a given object implements the DeploymentStepLogDto interface.
 */
export function instanceOfDeploymentStepLogDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "timestamp" in value;

    return isInstance;
}

export function DeploymentStepLogDtoFromJSON(json: any): DeploymentStepLogDto {
    return DeploymentStepLogDtoFromJSONTyped(json, false);
}

export function DeploymentStepLogDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeploymentStepLogDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': json['message'],
        'timestamp': (new Date(json['timestamp'])),
    };
}

export function DeploymentStepLogDtoToJSON(value?: DeploymentStepLogDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
        'timestamp': (value.timestamp.toISOString()),
    };
}

